export default "__VITE_ASSET__c58aba33__"